const HOST = process.env.REACT_APP_API_ENDPOINT;

export const getLocalToken = () => localStorage.getItem("token") || null;

export const getAuthToken = () => localStorage.getItem("authcheck") || null;

export const getHost = () => HOST;

export const getHeaders = () => {
  return {
    "Content-Type": "application/json",
    "Accept-Language": "en",
  };
};
